import React from 'react';

export const getLegalTexts = (internalName, subscription, planOption, companyName) => {
        if(internalName === "supercrosslive"){
            return (<div className="legal-texts">
            <p>Content available to ONLY outside USA + territories/possessions</p>
            <p>*Subscription Period ends June 30, 2019. ”Full Season” subscriptions are subject to auto-renewal</p>
          </div>)
        }

        else if(internalName === "bingeflix" || internalName==="qa-bingeflix"){
            return (<div className="legal-texts">
                By clicking the Verify and Purchase button, you agree to our Terms of Service and Privacy Policy.
                High speed internet required. Must be 18 or older to create account. Valid in the U.S. and Canada.
                Not compatible with all devices. Compatible devices, offers and entitlements subject to change at any time.
                Go to movieSPREE.com for more information including system requirements and access restrictions.
                Requires account setup.
          </div>)
        }
        else {
            return(<div className="legal-texts">
                By clicking the {subscription ? `Subscribe Now` : `Verify and ${ planOption }`} button, 
                you agree to our Terms of Service and Privacy Policy.
                You agree that your subscription will begin immediately and that you will not have a statutory
                right to cancel and receive a refund. This will not affect your  free trial period
                and you can still cancel at any time by logging into 'settings' and following the cancellation
                process. You agree that when your free trial ends, {companyName} will automatically continue
                your subscription and charge the subscription fee to your payment method on a monthly (or yearly)
                basis until you cancel. Cancellation will be effective at the end of each billing period. No
                refunds or credits are given for partially used periods.
            </div>)
        }
}